import React, {useState, useReducer, useEffect} from "react";
import { useHistory } from "react-router-dom";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import { Translation } from "./Translation";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Loader from "@amzn/meridian/loader";
import { RouteLink } from "./RouteLink";
import { ScrubStatsReducer, initialState } from "../../commons/reducer/ScrubStatsReducer";
import { withRefreshTime } from "../../util/CommonUtils";
import { ScrubInvokeButton } from "./ScrubInvokeButton";
import { Predicate } from "./ScrubInterface"
import {SCRUB_VIEW_TYPE} from "../../commons/constants/ScrubConstants";
import {ScrubInvocationAttributesButton} from "./scrubInvocationList";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";
import Box from "@amzn/meridian/box";
import {fetchLostTabStatus} from "../../commons/api/ScrubStatsAPI";



export const ScrubHome = () => {
    const [{stats, loading}, dispatch] = useReducer(ScrubStatsReducer, initialState);
    const [isLostTabEnabled, setIsLostTabEnabled] = useState(false);
    const {isMobile} = useDeviceLayout();

    useEffect(() => {
        const repeat = withRefreshTime(() => dispatch({ 
          type:"LOAD_DATA",
          data: {dispatcher: dispatch}
        }), 300000);
        return () => { if(repeat) { clearInterval(repeat) } }
    }, []);

    useEffect(() => {
        fetchLostTabStatus(setIsLostTabEnabled);
    }, []);

    return (<React.Fragment>

    <Predicate featureName="INVOKE_SCRUB" >
          <ScrubInvokeColumn isMobile={isMobile}/>
    </Predicate>

    <Column>
        <Row>
        <Alert type="informational" size="medium">
            <Translation stringId="scrub_informational" />
        </Alert>
        </Row>
        {
            loading 
            ? (<Row alignmentHorizontal="center" alignmentVertical="center" ><Loader /></Row>)
            : (<Column spacingInset="medium none none none">
                <ScrubRow view="scrub_missing" count={stats["MISSING_COUNT"]} isMobile={isMobile}/>
                {isLostTabEnabled && <ScrubRow view="scrub_lost" count={stats["LOST_COUNT"]} isMobile={isMobile}/>}
                </Column>)
        }

    </Column>    
    </React.Fragment>)
};

const ScrubInvokeColumn = ({isMobile}) => {

    return (
        <Row width="100%" widths={isMobile ? ["grid-6", "grid-6"] : ["grid-4", "grid-4"]}>
            <Box type="outline" spacingInset="300">
                <Row width="100%" widths={isMobile ? ["grid-10", "grid-2"] : ["grid-9", "grid-3"]}>
                <ScrubInvokeButton view="invoke_in_station_scrub"/>
                <ScrubInvocationAttributesButton view="invoke_in_station_scrub" />
                </Row>
            </Box>
            <Box type="outline" spacingInset="300">
                <Row width="100%" widths={isMobile ? ["grid-10", "grid-2"] : ["grid-9", "grid-3"]}>
                <ScrubInvokeButton view="invoke_on_road_scrub" />
                <ScrubInvocationAttributesButton view="invoke_on_road_scrub"/>
                </Row>
            </Box>
        </Row>
     )
};

const ScrubRow = ({view, count, isMobile}) => {
    const history = useHistory();
    return (
        <Row width="100%" widths={isMobile ? ["grid-3", "grid-9"] : ["grid-3", "grid-3"]}>
            <RouteLink to={`/scrubBoard/${view}`} >
                {`${count} `}
                <Translation stringId="packages" />
            </RouteLink>
            <Button onClick={() => history.push(`/scrubBoard/${view}`)} type="primary" size={isMobile ? "small" : "medium"}>
                <Translation stringId={SCRUB_VIEW_TYPE[view].review_button} />
            </Button>
        </Row>
    )
};


// WEBPACK FOOTER //
// ./src/components/scrub/ScrubHome.js